import {Component} from 'react';
import h from 'react-hyperscript';
import './Form.scss';
import {subhead} from 'Components/Typography/Typography';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

class SelectGroup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: '',
    };
  }

  componentDidMount() {
    this.setTitle();
  }

  componentDidUpdate(prevProps) {
    if (this.props !== prevProps) {
      this.setTitle();
    }
  }

  setTitle() {
    let value;
    if (this.props.value === '') {
      value = 'Choose';
    } else {
      value = this.props.value;
    }
    this.setState({
      title: value,
    });
  }

  render() {
    return (
      h('div', {
        className: 'form-group form-group__select',
      }, [
        h(subhead, {
          key: 0,
          className: 'margin-bottom--sm',
        }, this.props.label),
        h(Select, {
          key: this.props.id,
          id: this.props.id,
          name: this.props.name,
          value: this.state.title,
          fullWidth: true,
          onChange: (e) => {
            this.setState({
              title: e.currentTarget.getAttribute('data-value'),
            });
            this.props.onChange(e);
          },
        }, this.props.options.map((option, i) => (
          h(MenuItem, {
            key: `${i}__key`,
            id: option.id,
            value: option.title,
            className: 'text--grey',
            disabled: option.disabled,
          }, option.title)
        ))),
      ])
    );
  }
}

export default SelectGroup;
